export type MentionAnchorPosition = {
  left: number;
  top: number;
};

const TEXTAREA_MIRROR_STYLE_PROPS = [
  'box-sizing',
  'width',
  'height',
  'padding-top',
  'padding-right',
  'padding-bottom',
  'padding-left',
  'border-top-width',
  'border-right-width',
  'border-bottom-width',
  'border-left-width',
  'font-family',
  'font-size',
  'font-weight',
  'font-style',
  'line-height',
  'letter-spacing',
  'text-transform',
  'text-indent',
  'text-decoration',
  'text-align',
  'word-spacing',
  'white-space',
  'overflow-wrap',
  'word-break',
];

export const getMentionAnchorPosition = (
  input: HTMLTextAreaElement,
  atIndex: number,
): MentionAnchorPosition | null => {
  if (atIndex < 0 || typeof document === 'undefined') return null;

  const style = window.getComputedStyle(input);
  const mirror = document.createElement('div');

  TEXTAREA_MIRROR_STYLE_PROPS.forEach((prop) => {
    mirror.style.setProperty(prop, style.getPropertyValue(prop));
  });

  mirror.style.position = 'fixed';
  mirror.style.top = '0';
  mirror.style.left = '0';
  mirror.style.visibility = 'hidden';
  mirror.style.pointerEvents = 'none';
  mirror.style.overflow = 'hidden';
  mirror.style.whiteSpace = 'pre-wrap';
  mirror.style.wordBreak = 'break-word';

  mirror.textContent = input.value.slice(0, atIndex);
  const marker = document.createElement('span');
  marker.textContent = '@';
  mirror.appendChild(marker);
  document.body.appendChild(mirror);

  const inputRect = input.getBoundingClientRect();
  const left = inputRect.left + marker.offsetLeft - input.scrollLeft;
  const top = inputRect.top + marker.offsetTop - input.scrollTop;

  document.body.removeChild(mirror);

  return { left, top };
};
